<template>
    <div class="imgtemp">
        <div class="imgtemp-title-box SourceHanSansCN-Regular">
            <div class="imgtemp-title">{{ title }}</div>
            <el-button class="imgtemp-title-box-btn floating-btn" icon="el-icon-bottom" circle></el-button>
        </div>
        <img :src="src" alt="">
    </div>
</template>

<script>
export default {
    name: 'Imgtemp',
    props: {
        src: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {


        }
    }

}
</script>

<style scoped lang="less">
.imgtemp {
    width: 100%;
    height: 600px;
    position: relative;

    .imgtemp-title-box {
        position: absolute;
        top: 312px;
        left: 838px;
        text-align: center;

        .imgtemp-title {
            font-size: 60px;
            color: #FFFFFF;
            // text-shadow: 0px 0px 10px #0E0E0E;
            // text-shadow: 0 10px 10px rgba(29, 80, 139, 0.8);
            font-weight: bold;
        }

        .imgtemp-title-box-btn {
            width: 60px;
            height: 60px;
            margin-top: 60px;
            font-size: 24px;
        }
    }

    img {
        width: 100%;
        height: 100%;
    }
}


::v-deep .el-button {
    color: #606266;
}

::v-deep .el-button:focus,
.el-button:hover {
    color: #FFF !important;
    border-color: #0653B3 !important;
    background-color: #0653B3 !important;
    transition: all 0.3s;
}

.el-button:focus:not(:hover) {
    background-color: #FFF !important;
    color: #606266 !important;
    border: 1px solid #DCDFE6 !important;
}

/* 定义浮动动画 */
@keyframes float {
    0% {
        /* 起始位置 */
        transform: translateY(0px);
    }

    50% {
        /* 向上浮动 10px */
        transform: translateY(-30px);
    }

    100% {
        /* 回到起始位置 */
        transform: translateY(0px);
    }
}

/* 应用动画到按钮 */
.floating-btn {
    /* 应用名为 float 的动画 */
    animation-name: float;
    /* 动画持续时间为 2 秒 */
    animation-duration: 2s;
    /* 动画速度曲线为 ease-in-out，先慢后快再慢 */
    animation-timing-function: ease-in-out;
    /* 动画无限循环 */
    animation-iteration-count: infinite;
}
</style>